import { Model } from '@vuex-orm/core'

export default class DisqualifyReason extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'disqualifyReasons'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      name: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/DisqualifyReason.js